/**
 * Display helpers for person names stored as firstName + lastName.
 * Use only for UI formatting — APIs and DB store separate fields.
 */
export function formatPersonName(firstName, lastName) {
    return [firstName?.trim(), lastName?.trim()].filter(Boolean).join(' ');
}
export function personNameInitials(firstName, lastName) {
    const first = firstName?.trim()?.[0]?.toUpperCase() ?? '';
    const last = lastName?.trim()?.[0]?.toUpperCase() ?? '';
    const initials = `${first}${last}`;
    return initials || '?';
}
//# sourceMappingURL=person-name.utils.js.map